var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-transition"},[_c('div',{staticClass:"overflow-text"},_vm._l((100),function(c,i){return _c('overflow-transition-character',{key:i,attrs:{"index":i,"content":_vm.text[i] || '',"text":_vm.text}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30058736","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverflowTransition.vue
// module id = null
// module chunks = 